"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function replaceErrors(key, value) {
    if (value instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(value.entries())
        };
    }
    else if (value instanceof Error) {
        const error = {};
        Object.getOwnPropertyNames(value).forEach(function (key) {
            error[key] =
                // @ts-ignore
                value[key];
        });
        return error;
    }
    return value;
}
exports.default = replaceErrors;
//# sourceMappingURL=ErrorReplacerJSON.js.map